/**
 * Minimal ERC20 ABI for allowance/approve
 */

export const ERC20_ABI = [
  {
    inputs: [
      { internalType: 'address', name: 'owner', type: 'address' as const },
      { internalType: 'address', name: 'spender', type: 'address' as const },
    ],
    name: 'allowance',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' as const }],
    stateMutability: 'view' as const,
    type: 'function' as const,
  },
  {
    inputs: [
      { internalType: 'address', name: 'spender', type: 'address' as const },
      { internalType: 'uint256', name: 'amount', type: 'uint256' as const },
    ],
    name: 'approve',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' as const }],
    stateMutability: 'nonpayable' as const,
    type: 'function' as const,
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' as const },
    ],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' as const }],
    stateMutability: 'view' as const,
    type: 'function' as const,
  },
  {
    inputs: [
      { internalType: 'address', name: 'to',     type: 'address' as const },
      { internalType: 'uint256', name: 'amount', type: 'uint256' as const },
    ],
    name: 'transfer',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' as const }],
    stateMutability: 'nonpayable' as const,
    type: 'function' as const,
  },
] as const;
